<template>
    <div>
        <v-card-text>
            <v-img
                src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/warning-icon.svg"
                height="100"
                max-width="100"
                class="mx-auto"
            />

            <div class="d-flex mt-5">
                <v-img
                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/redirection.svg"
                    height="35"
                    width="36"
                    class="ml-2 mr-3"
                />
                <p class="mb-0 subtitle-2">
                    You will now be redirected to make a payment for this international transfer
                </p>
            </div>

            <div class="d-flex mt-5">
                <v-img
                    src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/transfer.svg"
                    height="45"
                    width="45"
                    class="mr-3"
                />
                <p class="mb-0 subtitle-2">
                    <span v-if="orderType === 'hybrid'">
                        You will be making payment to a virtual bank account
                    </span>
                    <span v-else>
                        You will be making payment to a matched peer’s bank account
                    </span>
                </p>
            </div>

            <div class="d-flex mt-5" v-if="isEUHybridOffer">
                <v-img
                    src="/images/card.png"
                    height="40"
                    width="45"
                    class="mr-3"
                />
                <p class="mb-0 subtitle-2">
                    Pay with a debit card to avoid processing delays {{ companyNameWithPrefix }}
                </p>
            </div>

            <v-row class="text-center justify-center">
                <v-col class="pa-0">
                    <v-img
                        class="mx-auto mb-5"
                        :class="isEUHybridOffer ? 'mt-5' : 'mt-10'"
                        :src="company_logo"
                        tile
                        width="180"
                        contain
                    ></v-img>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions class="px-4 justify-center">
            <v-btn
                class="text-capitalize px-10 rounded-lg"
                color="primary"
                dark
                depressed
                large
                @click.native="$emit('proceed')"
            >
                OK
            </v-btn>
        </v-card-actions>
  </div>
</template>

<script>
export default {
    props: {
        company: {
            type: Object,
            required: false,
        },
        company_logo: {
            type: String,
            required: true,
        },
        orderType: {
            type: String,
            required: true,
        },
        matcherCurrency: {
            type: String,
            required: true,
        },
    },
    computed: {
        isEUHybridOffer() {
            const { matcherCurrency, orderType } = this;
            return orderType === 'hybrid' && ['EUR', 'GBP'].includes(matcherCurrency);
        },
        companyNameWithPrefix() {
            if (!this.company) {
                return '';
            }

            return `on ${this.company.name}`;
        },
    },
};
</script>

<style>

</style>
